import React from 'react';
import styles from './radio-button.module.scss';
import useAccessibleClick from '../../../../../common/hooks/useAccessibleClick';

const RadioButton = ({ id, checked, onChange }) => {
  const ref = useAccessibleClick(onChange)

  return (
    <label id={id} tabIndex={0} ref={ref} className={styles.label}>
      <input type="radio" id={id} className={styles.radio} checked={checked} onClick={e => onChange(e)} />
      <span className={styles.fake} />
    </label>
  );
};

export default RadioButton;
